"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setToString = exports.combineSets = exports.subtractFromSet = exports.mapPropToSet = exports.mapPropToUniqueArray = exports.isEnumMember = exports.exhaustiveCheckSilent = exports.exhaustiveCheck = exports.getNumHoursInDay = exports.getNumDaysInMonth = exports.getNumDaysInYear = exports.dateMax = exports.dateMin = exports.konst = exports.snakeCaseToCamelCase = exports.arrayToMap = void 0;
const luxon_1 = require("luxon");
const arrayToMap = (array, key) => {
    const map = new Map();
    for (const item of array) {
        map.set(item[key], item);
    }
    return map;
};
exports.arrayToMap = arrayToMap;
const snakeCaseToCamelCase = (input) => input
    .split("_")
    .map((word, i) => i === 0
    ? word.toLowerCase()
    : `${word.charAt(0).toUpperCase()}${word.substr(1).toLowerCase()}`)
    .join("");
exports.snakeCaseToCamelCase = snakeCaseToCamelCase;
const konst = (value) => (..._args) => value;
exports.konst = konst;
const dateMin = (dates) => new Date(Math.min(...dates.map((date) => date.getTime())));
exports.dateMin = dateMin;
const dateMax = (dates) => new Date(Math.max(...dates.map((date) => date.getTime())));
exports.dateMax = dateMax;
const getNumDaysInYear = (year) => {
    const startOfYear = luxon_1.DateTime.local(year, 1, 1);
    const endOfYear = luxon_1.DateTime.local(year, 12, 31);
    return endOfYear.diff(startOfYear, "days").days + 1;
};
exports.getNumDaysInYear = getNumDaysInYear;
const getNumDaysInMonth = (month) => {
    const dt = luxon_1.DateTime.fromFormat(month, "yyyy-MM");
    if (!dt.daysInMonth) {
        throw new Error(`Invalid date created from YyyyMm: "${month}"`);
    }
    return dt.daysInMonth;
};
exports.getNumDaysInMonth = getNumDaysInMonth;
const getNumHoursInDay = (day, timezone) => {
    const dayLuxon = luxon_1.DateTime.fromJSDate(day, { zone: timezone });
    const startOfDay = dayLuxon.startOf("day");
    const startOfNext = startOfDay.plus({ days: 1 });
    const hoursInDay = startOfNext.diff(startOfDay, "hours").hours;
    return hoursInDay;
};
exports.getNumHoursInDay = getNumHoursInDay;
const exhaustiveCheck = (_, message) => {
    throw new Error(message);
};
exports.exhaustiveCheck = exhaustiveCheck;
const exhaustiveCheckSilent = (_) => { };
exports.exhaustiveCheckSilent = exhaustiveCheckSilent;
const isEnumMember = (enum_, candidate) => Object.values(enum_).includes(candidate);
exports.isEnumMember = isEnumMember;
const mapPropToUniqueArray = (arr, prop) => Array.from((0, exports.mapPropToSet)(arr, prop));
exports.mapPropToUniqueArray = mapPropToUniqueArray;
const mapPropToSet = (arr, prop) => new Set(arr.map((item) => item[prop]));
exports.mapPropToSet = mapPropToSet;
const subtractFromSet = (a, b) => {
    const result = new Set();
    for (const item of a) {
        if (!b.has(item)) {
            result.add(item);
        }
    }
    return result;
};
exports.subtractFromSet = subtractFromSet;
const combineSets = (a, b) => new Set([...a, ...b]);
exports.combineSets = combineSets;
const setToString = (set) => Array.from(set).join(", ");
exports.setToString = setToString;
//# sourceMappingURL=utils.js.map